import React from "react";
import { ReactComponent as SupportIcon } from "../../assets/icons/Support.svg";
import styles from "./SupportSection.module.css";
import { Crisp } from "crisp-sdk-web";
import {AppConsts} from 'core/AppConsts';


// تعریف `props` برای دریافت `profile`
interface SupportSectionProps {
  profile: any;
}

const SupportSection: React.FC<SupportSectionProps> = ({ profile }) => {


  const handleSupportClick = () => {
    // if (profile?.phone) {
    //   window.location.href = `tel:${profile.phone}`;
    // } else {
    //   alert("شماره تماس پشتیبانی موجود نیست.");
    // }


    Crisp.user.setPhone('+989121234567');
    Crisp.user.setNickname("Omid Ghorbani");


    Crisp.session.setData({
      user_id : "1",
      tenant : "1",
      tenant_id : "Default"
    });

    Crisp.chat.open()
  };

  return (
    <>
      <div className={styles.supportContainer}>
        <button
          className={styles.supportButton}
          onClick={handleSupportClick}
        >
          <span className={styles.supportText}>پشتیبانی</span>
          <span className={styles.supportIcon}>
            <SupportIcon className={styles.iconSVG} />
          </span>
        </button>
      </div>
      <div className={styles.divider}></div>
    </>
  );
};

export default SupportSection;
